export class TelefonbuchData {
  telephone: string | undefined;
  fax: string | undefined;
  mobile: string | undefined;
}
